import { fromJS } from "immutable";
import { CreateProcess } from "redux-process";

// utils
import get from "../../utils/GetNested";

export const PostInvites = CreateProcess({
	method: "POST",
	name: "PostInvites",
	type: "ADMIN:SEND_INVITES",

	request: (props) => {
		const { companyId } = props;
		if (companyId) {
			return {
				url: `/api/invites/${companyId}`,
				payload: {
					resend: props.payload,
				},
			};
		}
		return {
			url: "/api/invites/",
			payload: {
				resend: props.payload,
			},
		};
	},

	success: (response) => fromJS(response.data),
});

export const BulkDeactivateUsers = CreateProcess({
	method: "POST",
	name: "BulkDeactivateUsers",
	type: "ADMIN:DEACTIVATEUSERS",

	request: (props) => {
		const payload = get(props, ["params"], props.payload);
		return {
			url: "/administration/employees/bulk-deactivation/",
			payload,
		};
	},

	success: (response) => fromJS({ count: response.data }),
});

export const UserCsvUpload = CreateProcess({
	method: "POST",
	name: "UserCsvUpload",
	type: "ADMIN:USERCSVUPLOAD",

	request: (props) => {
		const formData = get(props, ["payload", "formData"], null);
		return {
			url: "/administration/employees/user-csv-upload/",
			payload: formData,
		};
	},

	success: (response) => fromJS({ count: response.data }),
});

export const DismissDeactivateUsers = CreateProcess({
	method: "POST",
	name: "dismissDeactivateUsers",
	type: "ADMIN:DISMISS_DEACTIVATE",

	request: (props) => {
		const payload = get(props, ["params"], props.payload);
		return {
			url: "/administration/employees/dismiss-deactivate/",
			payload,
		};
	},

	success: (response) => fromJS({ count: response.data }),
});
